import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import EventFormShell from '../components/EventFormShell.jsx'
import useEventFormController from '../hooks/useEventFormController.jsx'
import EditableCustomerEventCard from '../components/EditableCustomerEventCard.jsx'
import RehostModal from '../../../../components/RehostModal.jsx'

import '../css/EventHost.css';

export default function EventForm() {
  const navigate = useNavigate()

  const {
    formData,
    packages,
    tabs,
    coverImageFile,
    showSuccess,
    isSubmitting,
    handleInputChange,
    handleBlur,
    handleCoverImageChange,
    handleBannerImageChange,
    eventTypeOptions,
    handleEventTypeChange,
    customEventType,
    handleCustomEventTypeChange,
    addPackage,
    removePackage,
    handlePackageChange,
    addTab,
    removeTab,
    handleTabChange,
    handleSendRequest,
    backgroundMode,
    setBackgroundMode,
    imageBgColor,
    setImageBgColor,
    imageBgColor2,
    setImageBgColor2,
    bgImageUrl,
    setBgImageUrl,
    collectAllValidationMessages,
  } = useEventFormController({ navigate })

  const [activeTab, setActiveTab] = useState(0)
  const [showValidationModal, setShowValidationModal] = useState(false)
  const [validationMessages, setValidationMessages] = useState({
    information: [],
    clientTypes: [],
    packages: [],
    terms: [],
  })
  const [isFormValid, setIsFormValid] = useState(false)

  useEffect(() => {
    const messages = collectAllValidationMessages()
    const hasMissing = Object.values(messages).some((list) => list && list.length > 0)
    setIsFormValid(!hasMissing)
  }, [formData, packages, tabs, collectAllValidationMessages])

  const handleSubmitClick = () => {
    const messages = collectAllValidationMessages()
    const hasMissing = Object.values(messages).some((list) => list && list.length > 0)

    if (hasMissing) {
      setValidationMessages(messages)
      setShowValidationModal(true)
      return
    }

    handleSendRequest()
  }

  return (
    <EventFormShell
      currentSection={"eventInfo"}
      showEventInfo={() => {}}
      showClientTypes={() => {}}
      showPackagesTabs={() => {}}
      showTerms={() => {}}
      onBack={() => navigate('/organiser-dash')}
      onLogout={() => {
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        navigate('/')
      }}
    >
      <div style={{ padding: '10px 0' }}>
        <EditableCustomerEventCard
          formData={formData}
          tabs={tabs}
          packages={packages}
          coverImageFile={coverImageFile}
          activeTab={activeTab}
          onSelectTab={setActiveTab}
          handleInputChange={handleInputChange}
          handlePackageChange={handlePackageChange}
          addPackage={addPackage}
          removePackage={removePackage}
          addTab={addTab}
          removeTab={removeTab}
          handleTabChange={handleTabChange}
          onImageChange={handleCoverImageChange}
          onBackgroundImageChange={handleBannerImageChange}
          eventTypeOptions={eventTypeOptions}
          handleEventTypeChange={handleEventTypeChange}
          customEventType={customEventType}
          handleCustomEventTypeChange={handleCustomEventTypeChange}
          backgroundMode={backgroundMode}
          setBackgroundMode={setBackgroundMode}
          imageBgColor={imageBgColor}
          setImageBgColor={setImageBgColor}
          imageBgColor2={imageBgColor2}
          setImageBgColor2={setImageBgColor2}
          bgImageUrl={bgImageUrl}
          setBgImageUrl={setBgImageUrl}
        />

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1rem', gap: '0.75rem' }}>
          <button
            type="button"
            className="next-button"
            disabled={isSubmitting || !isFormValid}
            onClick={handleSubmitClick}
            style={{
              opacity: (!isFormValid && !isSubmitting) ? 0.4 : 1,
              cursor: (!isFormValid && !isSubmitting) ? 'not-allowed' : 'pointer',
              filter: (!isFormValid && !isSubmitting) ? 'grayscale(75%)' : 'none'
            }}
          >
            {isSubmitting ? 'Submitting...' : 'Submit Event Request'}
          </button>
        </div>

        {showValidationModal && (
          <RehostModal
            title="Please fill in the following:"
            onClose={() => setShowValidationModal(false)}
            showCloseButton
          >
            {validationMessages.information && validationMessages.information.length > 0 && (
              <div className="rehost-modal-section">
                <h4>Information</h4>
                <ul>
                  {validationMessages.information.map((item, idx) => (
                    <li key={`info-${idx}`}>{item}</li>
                  ))}
                </ul>
              </div>
            )}
            {validationMessages.clientTypes && validationMessages.clientTypes.length > 0 && (
              <div className="rehost-modal-section">
                <h4>Client Types & Images</h4>
                <ul>
                  {validationMessages.clientTypes.map((item, idx) => (
                    <li key={`client-${idx}`}>{item}</li>
                  ))}
                </ul>
              </div>
            )}
            {validationMessages.packages && validationMessages.packages.length > 0 && (
              <div className="rehost-modal-section">
                <h4>Packages & Tabs</h4>
                <ul>
                  {validationMessages.packages.map((item, idx) => (
                    <li key={`pkg-${idx}`}>{item}</li>
                  ))}
                </ul>
              </div>
            )}
            {validationMessages.terms && validationMessages.terms.length > 0 && (
              <div className="rehost-modal-section">
                <h4>Terms &amp; Conditions</h4>
                <ul>
                  {validationMessages.terms.map((item, idx) => (
                    <li key={`terms-${idx}`}>{item}</li>
                  ))}
                </ul>
              </div>
            )}
          </RehostModal>
        )}

        {showSuccess && (
          <RehostModal title="Event request submitted">
            <p>Event request submitted successfully!</p>
          </RehostModal>
        )}
      </div>
    </EventFormShell>
  )
}

